import { useEffect, useState } from "react";
import { requestGetEventDataForAttendance } from "services/events/attendance";
import { eventsSessionStorage } from "services/storage/events";

const useEventDataForAttendance = () => {
	const [eventData, setEventData] = useState({
		eventId: 0,
		dateEventId: 0,
		isWorkShop: false,
		title: "",
		formattedDate: {
			onlyDay: null,
			manyDays: null,
		},
		isPresential: true,
		schedule: {
			date: 0,
			time: {
				start: 0,
				end: 0,
			},
		},
	});
	const [isLoaded, setIsLoaded] = useState(false);
	useEffect(() => {
		fillEventData();
	}, []);
	async function fillEventData() {
		const eventDataSessionStorage =
			eventsSessionStorage.eventDataForAttendance.get();
		const data = await requestGetEventDataForAttendance(
			eventDataSessionStorage.dateEventId
		);
		setEventData(data);
		setIsLoaded(true);
		return data;
	}
	const teacherMustBeTakeHisAttendance = () => {
		return eventData.isPresential && eventData.isWorkShop;
	};
	return {
		value: eventData,
		fill: fillEventData,
		isLoaded,
		teacherMustBeTakeHisAttendance,
	};
};

export default useEventDataForAttendance;
